export const SUBMIT_FORM_REQUEST = 'Home/SUBMIT_FORM_REQUEST';
export const SUBMIT_FORM_SUCCESS = 'Home/SUBMIT_FORM_SUCCESS';
export const SUBMIT_FORM_FAILURE = 'Home/SUBMIT_FORM_FAILURE';

export const GET_ASSISTANCE_LIST_REQUEST = 'Home/GET_ASSISTANCE_LIST_REQUEST';
export const GET_ASSISTANCE_LIST_SUCCESS = 'Home/GET_ASSISTANCE_LIST_SUCCESS';
export const GET_ASSISTANCE_LIST_FAILURE = 'Home/GET_ASSISTANCE_LIST_FAILURE';
